import { feedbackcard } from '@yes.technology/react-toolkit'
import { FlatActivityModel, Translate } from 'types/shared'

type StepErrorMessage = {
  title: string
  description?: string
}

export const showError = ({ error }: { error: StepErrorMessage }) => {
  const { title, description } = error

  if (!title) return false

  feedbackcard(title, {
    type: 'error',
    message: description || ''
  })

  return true
}

type ShowStepErrorMessagesProps = {
  stepName: string
  invalidActivities: {
    helperText: string
    activityModel: FlatActivityModel
    parentPath?: string[]
  }[]
  t: Translate
}

export const getStepErrorMessages = ({
  stepName,
  invalidActivities,
  t
}: ShowStepErrorMessagesProps): StepErrorMessage[] => {
  if (!invalidActivities.length) {
    return []
  }

  return [
    ...invalidActivities.flatMap((invalidActivity) => {
      if (invalidActivity.activityModel.content_type === 'agreement_term') {
        return {
          title: invalidActivity.activityModel.error_text?.des || stepName
        }
      }

      const hasInvalidFormat =
        invalidActivity.helperText === 'activity-input.validation.wrong_format'
      const fieldLabel = invalidActivity.activityModel.display_text?.des
      const hasFieldLabel = !!fieldLabel?.trim()

      if (!hasFieldLabel) {
        return {
          title: t('step.validation.message-generic-is-required-field-title'),
          description: t(
            'step.validation.message-generic-is-required-field-description'
          )
        }
      }

      if (invalidActivity.parentPath?.length) {
        const groupIndex = parseInt(
          invalidActivity.parentPath.at(-1)!.toString()
        )

        return {
          title: t(
            hasInvalidFormat
              ? 'step.validation.message-invalid-format-in-activity-group'
              : 'step.validation.message-is-required-field-in-activity-group',
            {
              field: fieldLabel,
              groupNumber: String(groupIndex + 1)
            }
          )
        }
      }

      return {
        title: t(
          hasInvalidFormat
            ? 'step.validation.message-invalid-format'
            : 'step.validation.message-is-required-field',
          {
            field: fieldLabel
          }
        )
      }
    }),
    ...(invalidActivities.length > 1
      ? [{ title: t('step.validation.message-all-required-fields') }]
      : [])
  ]
}
